import { t } from "@lingui/macro";

import { LoadingSpinner } from "@whoosh/design-system/src/components/display/Loader/LoadingSpinner";
import {
  Text,
  HStack,
  Box,
} from "@whoosh/design-system/src/components/primitive";

export const NoAvailableTeeTimes = () => {
  return (
    <HStack
      borderRadius="4"
      backgroundColor="surface-secondary"
      padding={4}
      paddingLeft={6}
      gap={5}
      alignItems="center"
      marginTop={6}
    >
      <Box
        backgroundColor="surface-primary"
        borderRadius="6"
        width={32}
        height={32}
        justifyContent="center"
        alignItems="center"
      >
        <LoadingSpinner />
      </Box>
      <Text>{t`No available tee times`}</Text>
    </HStack>
  );
};
